import React from "react";
import {FormControlLabel, Radio, RadioGroup} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import FormLabel from "@material-ui/core/FormLabel";
import {uid} from "react-uid";

const RadioGroupComponent = (props) => {
    const {component = {}} = props;
    const {properties, styles: sourceStyles} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage)
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{multiLanguageLabel}</FormLabel>
            <RadioGroup
                row={styles.orientation === 'horizontal'}
            >
                {
                    properties.items ? properties.items.map(item => {
                        return (
                            <FormControlLabel
                                key={uid(item)}
                                value="radio1" control={<Radio size={styles.size}/>} label={item}
                                labelPlacement={styles.labelPlacement}
                                disabled
                            />
                        )
                    }) : (
                        <>
                            <FormControlLabel value="radio1" control={<Radio/>} label="Radio 1"
                                              labelPlacement={styles.labelPlacement}
                                              disabled
                            />
                            <FormControlLabel value="radio2" control={<Radio/>} label="Radio 2"
                                              labelPlacement={styles.labelPlacement}
                                              disabled
                            />
                        </>
                    )
                }
            </RadioGroup>
        </FormControl>

    )

}

export default RadioGroupComponent;